/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
import React from 'react'
import styled from 'styled-components'
import Image from 'next/legacy/image'
import { IoMdStar } from 'react-icons/io'
import PropTypes from 'prop-types'
import { Typography } from 'components/common/typography'

const ReviewStyled = styled.article`
  padding: 2px;
  margin: 16px 0;
  border-radius: 16px;
  overflow: hidden;
  ${({ idx }) => ((idx % 2 === 0)
    ? `
      background: linear-gradient(147.52deg, #874053 23.89%, #9499A6 67.19%);
    `
    : `
        background: linear-gradient(147.52deg, #36DFE5 23.89%, #9499A6 67.19%);
      `
  )};
  .review-container {
    ${({ idx }) => ((idx % 2 === 0)
    ? `
        background: linear-gradient(0deg, rgba(41, 21, 68, 0.5), rgba(41, 21, 68, 0.5)), linear-gradient(123.82deg, #AC4F68 -13.64%, #0E0230 87.27%);
        `
    : `
        background: linear-gradient(0deg, rgba(41, 21, 68, 0.5), rgba(41, 21, 68, 0.5)), linear-gradient(123.82deg, #209EAF -13.64%, #282F42 87.27%);
    `)};
    border-radius: 16px;
    padding: 16px;
  }
  .review-author {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
    overflow: hidden;
    transition: .2s;
    background: var(--secondary);
    &:hover {
      box-shadow: 0 0 0 2px #1da1f2;
    }
  }
  .rating {
    display: grid;
    grid-template-columns: repeat(5, 16px);
    grid-column-gap: 4px;
  }
  .group {
    display: flex;
    flex-direction: column;
    width: auto;
  }

`

function Review({
  userAvatar, firstName, lastName, comment, stars, idx,
}) {
  const array = []
  for (let i = 0; i < stars; i++) {
    array.push({ active: true })
  }
  if (array.length < 5) {
    const missing = 5 - array.length
    for (let i = 0; i < missing; i++) {
      array.push({ active: false })
    }
  }
  return (
    <ReviewStyled idx={idx}>
      <div className="review-container">
        <div className="review-author">
          <div className="avatar">
            <Image
              src={userAvatar}
              alt={`${firstName} ${lastName}`}
              width={40}
              height={40}
            />
          </div>
          <div className="group">
            <Typography as="h4" color="var(--white)" font="regularBold" transform="capitalize">{`${firstName} ${lastName}`}</Typography>
            <div className="rating">
              {array.map((start, index) => <IoMdStar key={index} color={start.active ? '#F9C126' : '#AEB7C1'} size={16} />)}
            </div>
          </div>
        </div>
        <Typography font="regular" color="var(--neutral10)">{comment}</Typography>
      </div>
    </ReviewStyled>
  )
}

Review.defaultProps = {
  lastName: '',
  comment: '',
}

Review.propTypes = {
  userAvatar: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string,
  stars: PropTypes.number.isRequired,
  comment: PropTypes.string,
}

const ReviewMemo = React.memo(Review)

export default ReviewMemo
